import { TextCell } from '@common/components/TextCell';

interface EmailCellProps {
	email: string;
}

export const EmailCell = ({ email }: EmailCellProps) => {
	return <TextCell value={email} />;
};
